import React, { useRef, useEffect, useContext } from 'react';
import {
    NavLink,
    useHistory
} from "react-router-dom";

import $ from 'jquery';
import { UserContext } from '../../../context/provider/UserProvider';

export const Menu = React.forwardRef(({isOpen, openMenu, closeMenu, toggleContentMenu}, ref) => {
    const { stateUser } = useContext(UserContext)
    const splitRef = useRef();

    useEffect(() => {
        const li = document.getElementsByClassName("li-nav-div")

        for (var i = 0; i < li.length; i++) {

            const linkSubMenu = li[i].parentNode.querySelectorAll('.li-a-submenu')

            let up = true

            for (var j = 0; j < linkSubMenu.length; j++) {
                const ulSubMenu = linkSubMenu[j].parentNode.parentNode.parentNode

                if (linkSubMenu[j].classList.contains("active")) {
                    const liNavDiv = ulSubMenu.parentNode;
                    liNavDiv.querySelector('.li-nav-div').children[0].classList.add("active")
                    up = false
                }
            }

            if(up){
                $(li[i]).parent().children('ul').slideUp();     //encoje los que no contengan una vista activa
            }else{
                $(li[i]).parent().children('ul').slideDown();   //despliega el menu que tenga la vista activa
            }
        }

    })

    const toggleMenu = (e) => {
        let element = e.target

        while (!element.classList.contains('li-nav-div')) {
            element = element.parentNode
        }

        const menuParents = $('.li-nav-div')
        for (let i = 0; i < menuParents.length; i++) {  //cuando existan mas menus
            const menuParent = menuParents[i]
            if (element !== menuParent) {
                menuParent.children[0].classList.remove('active')
                $(menuParent.parentNode.children[1]).slideUp()
            }
        }

        if (element.children[0].classList.contains('active')) {
            $(element.parentNode.querySelector('.ul-submenu')).slideUp();
        } else {
            $(element.parentNode.querySelector('.ul-submenu')).slideDown();
        }
        element.children[0].classList.toggle('active')
    }


    const cerrarMenu = (nomTitulo) =>{
        document.title = 'XProject' + ' | ' + (nomTitulo||'')
        toggleContentMenu(false)
    }

    return (
        <>
            <div className={`flex menu dark:text-white lg:absolute relative h-full lg:h-[93%]  lg:bottom-0 w-[300px] ${isOpen ? 'active' : ''}`}>
                <ul ref={ref} className="ul-nav py-0 bg-[#02050A]">
                    <li id="li" className="waves-effect ul-nav-li active-li">
                        <div className="li-nav-div" onClick={(e) => toggleMenu(e)}>
                            <a className="nav-link li-a">
                                <div className="w-full flex justify-between">
                                    <span className="text-menu">Registros</span>
                                    <i className="icon-menu fas fa-sort-down"></i>
                                </div>
                            </a>
                        </div>
                        <ul className="ul-submenu p-0">
                            {/* <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/bitacora-solicitudes'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu()}>
                                        <span className="text-sub-menu" >Bitácora de Solicitudes </span>
                                    </NavLink>
                                </div>
                            </li> */}
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/proyectos'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Gestión de proyectos')}>
                                        <span className="text-sub-menu" >Gestión de proyectos</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/gestion-produccion-por-metas'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Gestión de produccion por metas')}>
                                        <span className="text-sub-menu" >Producción por metas</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/incidencias'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Atención de incidencias derivadas')}>
                                        <span className="text-sub-menu" >Atención de incidencias derivadas</span>
                                    </NavLink>
                                </div>
                            </li>
                        </ul>
                    </li>

                    <li id="li" className="waves-effect ul-nav-li active-li">
                        <div className="li-nav-div" onClick={(e) => toggleMenu(e)}>
                            <a className="nav-link li-a">
                                <div className="w-full flex justify-between">
                                    <span className="text-menu">Gestión del personal</span>
                                    <i className="icon-menu fas fa-sort-down"></i>
                                </div>
                            </a>
                        </div>


                        <ul className="ul-submenu p-0">
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/tareas'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu()}>
                                        <span className="text-sub-menu" >Tareas</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/actividades-personal'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Actividades del personal')}>
                                        <span className="text-sub-menu" >Actividades Personal</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/actividades-incidencia'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Actividades por incidencia')}>
                                        <span className="text-sub-menu" >Actividades Incidencia</span>
                                    </NavLink>
                                </div>
                            </li>
                            {/* <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/gestion-actividades'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu()}>
                                        <span className="text-sub-menu" >Gestión de Actividades</span>
                                    </NavLink>
                                </div>
                            </li> */}
                        </ul>
                    </li>


                    <li id="li" className="waves-effect ul-nav-li active-li">
                        <div className="li-nav-div" onClick={(e) => toggleMenu(e)}>
                            <a className="nav-link li-a">
                                <div className="w-full flex justify-between">
                                    <span className="text-menu">Reportes</span>
                                    <i className="icon-menu fas fa-sort-down"></i>
                                </div>
                            </a>
                        </div>


                        <ul className="ul-submenu p-0">
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/consultas-reportes'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Consultas y reportes')}>
                                        <span className="text-sub-menu" >Consultas y reportes</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/cronograma'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Calendario de ticket')}>
                                        <span className="text-sub-menu" >Calendario de ticket</span>
                                    </NavLink>
                                </div>
                            </li>
                        </ul>

                    </li>

                    <li id="li" className="waves-effect ul-nav-li active-li">
                        <div className="li-nav-div" onClick={(e) => toggleMenu(e)}>
                            <a className="nav-link li-a">
                                <div className="w-full flex justify-between">
                                    <span className="text-menu">Gestión de conocimiento</span>
                                    <i className="icon-menu fas fa-sort-down"></i>
                                </div>
                            </a>
                        </div>


                        <ul className="ul-submenu p-0">
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/inventario-servicios'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Inventario de servicios')}>
                                        <span className="text-sub-menu" >Inventario de servicios</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/inventario-servidores'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Inventario de servidores')}>
                                        <span className="text-sub-menu" >Inventario de servidores</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/inventario-dominios'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Inventario de dominios')}>
                                        <span className="text-sub-menu" >Inventario de dominios</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/inventario-subdominios'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Inventario de subdominios')}>
                                        <span className="text-sub-menu" >Inventario de subdominios</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/lecciones-aprendizaje'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Lecciones y aprendizaje')}>
                                        <span className="text-sub-menu" >Lecciones y aprendizaje</span>
                                    </NavLink>
                                </div>
                            </li>
                            <li id="li-submenu" className="waves-effect ul-nav-li-submenu">
                                <div className="li-nav-div-submenu">
                                    <NavLink to={'/documentacion-tecnica'} className="nav-link li-a-submenu" onClick={()=>cerrarMenu('Documentación técnica')}>
                                        <span className="text-sub-menu" >Documentación técnica</span>
                                    </NavLink>
                                </div>
                            </li>
                        </ul>

                    </li>


                </ul>





                <div ref={splitRef} id="split" onClick={() => toggleContentMenu(false)} className="flex items-center lg:hidden justify-center w-[15px] bg-[#47596c] hover:bg-[#3b4a5a] cursor-pointer">
                    <i id="icon-split" className="icon-split fas fa-caret-square-left text-[12px]"></i>
                </div>
            </div>
        </>
    )
})